import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "offer-verified__footer-container" }
const _hoisted_2 = { class: "offer-verified__footer" }

import RoundedButton from '@lmt-rpb/RoundedButton/RoundedButton.vue';
import { gaSelectContentAttr } from 'src/utils/analytics';

interface Props {
	ibeCheckoutUrl: string;
	buttonText: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OfferVerifiedFooter',
  props: {
    ibeCheckoutUrl: {},
    buttonText: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(RoundedButton, _mergeProps({
        as: "a",
        href: _ctx.ibeCheckoutUrl,
        rel: "nofollow"
      }, _unref(gaSelectContentAttr)({ cId: 'offerlist_verifiedoffer_button' }), {
        theme: "extra",
        class: "offer-verified__price-button"
      }), {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.buttonText), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 16 /* FULL_PROPS */, ["href"])
    ])
  ]))
}
}

})